var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"front_wrap"},[_c('BreadCrumb',{attrs:{"crumb":"内容统计"}}),_vm._v(" "),_c('CountPannelTwo'),_vm._v(" "),_c('CurveGraphTwo'),_vm._v(" "),_c('PieGraphTwo'),_vm._v(" "),_c('PieGraphThree')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db51ea3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/ContentStatistics.vue
// module id = null
// module chunks = 